import type { Transaction } from '../db/database'
import { formatSigned } from '../lib/money'
import { formatDay } from '../lib/dates'
import { Icon } from './Icon'
import './ConfirmDeleteSheet.css'

/**
 * La confirmation avant de retirer une opération.
 *
 * Une suppression d'argent ne se rattrape pas d'un geste : le raccourci par
 * glissement est fait pour être rapide, et rapide veut dire déclenché par
 * mégarde. On redit donc CE QU'ON SUPPRIME — montant, nom, date — plutôt que
 * de poser une question abstraite à laquelle on répond oui sans regarder.
 */
export function ConfirmDeleteSheet(
  { transaction, label, onConfirm, onCancel }: {
    transaction: Transaction
    label: string
    onConfirm: () => void
    onCancel: () => void
  },
) {
  return (
    <div className="sheet-backdrop" role="dialog" aria-modal="true"
         aria-label="Supprimer cette opération">
      <div className="sheet confirm-sheet">
        <header>
          <h2>Supprimer cette opération ?</h2>
        </header>

        <p className="confirm-what">
          <strong>{label}</strong>
          <span className={`tabular ${transaction.direction === 'income' ? 'is-income' : 'is-expense'}`}>
            {formatSigned(transaction.amount, transaction.direction)}
          </span>
          <span className="confirm-date">{formatDay(transaction.operation_date)}</span>
        </p>

        <p className="confirm-help">
          Le montant sortira de tes soldes. Si cette opération venait d'une
          journée prévue, la journée redeviendra à confirmer.
        </p>

        <div className="confirm-actions">
          <button type="button" className="confirm-go" onClick={onConfirm}>
            <Icon name="trash" size={16} /> Supprimer
          </button>
          <button type="button" className="confirm-cancel" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  )
}
